import { Form, Select, Input, Button } from "antd";
import { observer } from "mobx-react";
import React from "react";
import { familyStore } from "../../store/family/FamilyStore";

export const FamilyAddNewChild = observer(({ onNew }) => {
  const { addChild } = familyStore;

  return (
    <>
      <Form.Item label="First Name" name="firstName" rules={[{ required: true, message: "Please input first name" }]}>
        <Input maxLength={50} placeholder="Enter first name" />
      </Form.Item>
      <Form.Item name="schoolId" label="School" rules={[{ required: true, message: "Please select school" }]}>
        <Select
          style={{ width: "100%" }}
          placeholder="Enter school name to search"
          showSearch
          filterOption={false}      
          onSearch={(val) => addChild.setKeyword(val)}
          onChange={(val) => addChild.newStore.onSchool(val)}
        >
          {addChild.orgs.map((p: any) => (
            <Select.Option key={p.id} value={p.id}>
              {p.name}
            </Select.Option>
          ))}
        </Select>
      </Form.Item>
      <Form.Item label="Grade" shouldUpdate required>
        {() => {
          return (
            <Form.Item name="grade" noStyle rules={[{ required: true, message: "Please input grade" }]}>
              <Select style={{ width: "100%" }} placeholder="Please select">
                {addChild.newStore.grades.map((p) => (
                  <Select.Option key={p} value={p}>
                    {p}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          );
        }}
      </Form.Item>
      <Form.Item label="Email" name="email" rules={[{ type: "email", message: "Erroneous email address format." }]}>
        <Input placeholder="Enter email" />
      </Form.Item>
      <Form.Item wrapperCol={{ span: 16, offset: 8 }}>
        <Button type="primary" onClick={onNew}>
          Submit
        </Button>
      </Form.Item>
    </>
  );
});
